import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function LowCellSignalIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <rect x="3" y="14" width="3" height="6" rx="0.5" fill="currentColor" />
            <rect x="8" y="11" width="3" height="9" rx="0.5" fill="currentColor" opacity="0.3" />
            <rect x="13" y="8" width="3" height="12" rx="0.5" fill="currentColor" opacity="0.3" />
            <rect x="18" y="5" width="3" height="15" rx="0.5" fill="currentColor" opacity="0.3" />
        </SvgIcon>
    )
}
